import PropertyGridWithoutSliderContainer from "../../../components/property/other/PropertyGridWithoutSlider";

const PropertyGridWithoutSlider = () => {
  return <PropertyGridWithoutSliderContainer />;
};

export default PropertyGridWithoutSlider;
